"use strict";
(globalThis["webpackChunktvg_shopify_theme"] ||= []).push([[6748],{

/***/ 2336
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* unused harmony export default */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);
/* harmony import */ var _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(271);
/* harmony import */ var _core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8306);




class B2bCollectionController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static values = {
    customerState: String
  }

  static targets = ['checkoutButton']

  static outlets = ['b2b-collection-item']

  async connect() {
    const availableSkus = await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].getAvailableSkus(this.customerStateValue)
    this.b2bCollectionItemOutlets.forEach((item) => {
      item.checkIfAvailable(availableSkus)
    })
  }

  async updateCheckoutPrice() {
    const response = await fetch('/cart.js')
    const cart = await response.json()
    const totalPrice = cart.items.reduce((acc, item) => acc + item.price * item.quantity, 0)

    this.checkoutButtonTarget.textContent = `Checkout Now ${(0,_core_shopify_format_money__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(totalPrice)}`
  }
}

Stimulus.register('b2b-collection', B2bCollectionController)


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(2336)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);